import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { first } from 'rxjs/operators';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../../../../../../src/app/shared/services/authentication.service';
import { EnvironmentService } from '../../../../../../src/app/services/environment.service';

import { SettingsState } from '../../../../../../src/app/services/settings/settings.state';
import * as SettingsAction from '../../../../../../src/app/services/settings/settings.action';

import { User } from '../../../../../../src/app/models/user/user';

import { SettingsPreview } from '../../../../../../src/app/models/settings/settings';

import * as Models from '../../../../../../src/app/models/commonModels';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {

    @Select(SettingsState.Settings)
    settings$: Observable<Models.Response<SettingsPreview>>;

    
    public rememberLogin = false;
    public selected = false;

    loginForm: FormGroup;
    loading = false;
    submitted = false;
    returnUrl: string;
    tfaUrl: string = "/tfa";
    error = '';

    constructor(
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private authenticationService: AuthenticationService,
        public environment: EnvironmentService,
        public store: Store,
    ) {
        // redirect to home if already logged in
      if (this.authenticationService.currentUserValue &&
          this.authenticationService.currentUserValue.Token) {
            this.router.navigate(['/']);
         }
    }

    ngOnInit() {
        this.rememberLogin = JSON.parse(localStorage.getItem('RememberLogin'));
        this.loginForm = this.formBuilder.group({
            username: ['', Validators.required],
            password: ['', Validators.required]
        });

        this.settings$.subscribe((data) => {
            if (data && data.Success == true) {
                this.environment.settings = data.Item; 
                localStorage.setItem('psSettingsKey', JSON.stringify(data.Item));
            }
        })

        this.returnUrl = '/home';
    }

    // convenience getter for easy access to form fields
    get f() { return this.loginForm.controls; }

    onContextChange() {
        this.selected = true;
    }

    onSubmit() {
        this.submitted = true;

        // stop here if form is invalid
        if (this.loginForm.invalid) {
            return;
        }

        this.loading = true;
        this.authenticationService.login(this.f.username.value, this.f.password.value, this.rememberLogin,null)
            .pipe(first())
            .subscribe(
              data => {

                if (data.Token) {

                  this.store.dispatch(new SettingsAction.Get());
                  this.router.navigate([this.returnUrl]);
                }
                else {
                  this.router.navigate([this.tfaUrl]);
                }


                },
                error => {
                    this.error = 'Niepoprawny numer rejestracyjny lub numer VIN.';
                    this.loading = false;
                });
    }
}
